import { render, staticRenderFns } from "./PermissionModal.vue?vue&type=template&id=d2c41682&scoped=true&"
import script from "./PermissionModal.vue?vue&type=script&lang=js&"
export * from "./PermissionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c41682",
  null
  
)

export default component.exports